export default {
  desktop: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/layouts/desktop.vue").then(m => m.default || m),
  mobile: () => import("/home/msservice/workspace/MAYBE/STG/STG-MAYBE-V3-FE/maybe-v3-fe-stg/layouts/mobile.vue").then(m => m.default || m)
}